/* eslint-disable */
import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, del, get, post, ServiceResult } from "@insite/client-framework/Services/ApiService";

export interface ConfiguratorDataApiParameter extends ApiParameter {
    CID?: string;
}

export interface ValidProducts {
    productId: string;
    qty: number;
    unitOfMeasure: string;
}

const configuratorUrl = "api/v1/GerrieConfigurator";

export type ConfiguratorResult = {
    productsCanAddToCart: ValidProducts[];
    productsNotInPlatform: string[];
};

export type ConfiguratorMissingProductRequest = {
    customerMessage: string;
    products: string[];
    requestingCustomer: string;
};

// eslint-disable-next-line require-await
export async function getConfiguratorProducts(parameter: string): Promise<ServiceResult<ConfiguratorResult>> {
    const resultValue = await get<ConfiguratorResult>(`${configuratorUrl}/GetProductsFromCid?cid=${parameter}`, {});
    return {
        successful: true,
        result: resultValue,
    };
}

export async function sendConfiguratorProductRequestEmail(parameter: ConfiguratorMissingProductRequest): Promise<ServiceResult<string>> {
    const resultValue = await post<ConfiguratorMissingProductRequest, string>(`${configuratorUrl}/SendProductRequestEmail`, parameter);
    return {
        successful: true,
        result: resultValue,
    };
}